import React from 'react';
import { connect, Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Selectors from './store/selectors';
import * as actions from './store/actions';
import Router from './router';
import GlobalLoader from './shared/components/GlobalLoader';
import style from './styles/styles.module.css';

const App = ({ store, baseRoute, showLoader }) => {
  return (
    <Provider store={store}>
      <GlobalLoader show={showLoader} />
      <BrowserRouter basename={baseRoute}>
        <div className={style.AppWrapper}>
          <Router />
        </div>
      </BrowserRouter>
    </Provider>
  );
};

export default connect(
  Selectors,
  actions
)(App);
